var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"text-center"},[_c('v-col',[_c('span',{staticClass:"text-h4 white--text"},[_vm._v(_vm._s(_vm.$t('finished.title')))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }